<div [ngStyle]="{'width': state.widthBundlesMainPage}">
  <h1 class="bundles-main-page-title" data-cy="bundles-main-page-title">Bundles</h1>

  <app-tabs (selectedTabs)="setSelectedTabs($event)" [tabsData]="tabsData"></app-tabs>

  <ng-template #periodsTableTemplate>
    <div class="period-view-wrapper">

      <app-global-search-criteria
        [globalSearchCriteriaConfiguration]="state.bundlesGlobalDynamicSearchConfiguration"
        [globalSearchCriteriaModel]="state.bundlesGlobalSearchModel"
        [resetGlobalSearchCriteria]="resetGlobalSearchCriteria"
      (globalSearchCriteria)="globalSearchCriteriaHandler($event)"></app-global-search-criteria>

      <div class="period-view-tool-bar-buttons">
        <app-segmented-button #changeViewTabs
          (selectedOption)="changePeriodViewTab($event)"
        [options]="$safeNavigationMigration(state?.listTabOptions)"></app-segmented-button>

        @if (state.showAutoCloseBundles) {
          <div class="auto-close-bundles-section-wrapper" data-cy="auto-close-bundles-section">
            <app-switch-button
              [switchButtonConfiguration]="bundlesAutoCloseConfiguration.buttonConfiguration"
              [switchButtonModel]="getAutoCloseSwitchModel"
              (switch)="setAutomaticBundlesClosure($event)"
              data-cy="auto-close-bundles-switch">
            </app-switch-button>
            <div>
              <app-tooltip [dynamic]="false"
                tooltipCustomClass="auto-close-bundles-section-tooltip-width"
                [message]="autoCloseTooltip">
                <div class="auto-close-bundles-section-icon-wrapper">
                  <span class="iwp-icon-gen_info_info auto-close-bundle-icon"
                  data-cy="auto-close-bundles-icon"></span>
                </div>
              </app-tooltip>
            </div>
          </div>
        }
      </div>


      <div>
        @switch (state.selectedTab) {
          @case (periodViewTabs.PERIODS) {
            <app-periods-table
              (refreshPeriodData)="updatePeriodData($event)"
              (refreshTableData)="updateTableData()"
              [periodsList]="periodsList">
            </app-periods-table>
          }
          @case (periodViewTabs.BUNDLES) {
            <app-bundles-view
              (refreshPeriodData)="updatePeriodData($event)"
              (refreshTableData)="updateTableData()">
            </app-bundles-view>
          }
          @case (periodViewTabs.SETTLEMENTS) {
            <app-settlements-view></app-settlements-view>
          }
        }
      </div>

      @if (hasPagination()) {
        <app-pagination (pageNumber)="changePage($event)"
          [collectionSize]="search.totalResults"
          [pageSize]="search.pageSize"
          [page]="search.pageNumber"
          data-cy="periods-result-table-pagination">
        </app-pagination>
      }
    </div>

    @if (spinnerObservable | async) {
      <div class="spinner-container">
        <app-loading-spinner class="center-spinner"></app-loading-spinner>
      </div>
    }
  </ng-template>
</div>

@if (showBundlingSettings) {
  <app-bundling-settings
    (closeForm)="closeBundlesSettings()"
    (reloadPage)="updateTableData()"
    [tabsInfo]="state.bundlingSettingsTabs"
    [activeTabs]="bundlingSettingsActiveTabs"
    [formData]="state.bundlingSettingsFormData"
    [formDropdownsData]="state.bundlingSettingsDropdowns"
    [isEditMode]="state.bundlingSettingsEditMode">
  </app-bundling-settings>
}

<ng-template #autoCloseTooltip>
  <b>{{bundlesAutoCloseConfiguration.tooltipTitle}}</b>
  <p>{{bundlesAutoCloseConfiguration.baseTooltipText}}</p>
  <p>Last changed by: {{getAutoCloseLastChangedBy| prettyPrintClosedBy | undefinedValue}}</p>
  <p>Last changed on: {{getAutoCloseLastChangedOn | undefinedValue}}</p>
</ng-template>
